import KunLoading24 from './src/index'

KunLoading24.install = function (Vue) {
	Vue.component(KunLoading24.name, KunLoading24);
}

export default KunLoading24;
